import type { LoaderFunctionArgs } from "react-router-dom";
import { getLandingPageDataByName } from "@lemonadetraining/web-shared";
import {
  LANDING_PAGE_REFUSAL_REASON,
  type GetLandingPageByNameResponse,
  type LandingPageDoc,
} from "@lemonadetraining/contracts";

// Kept out of LandingPage.tsx so the route declares `loader` statically and the
// call starts while the page chunk is still downloading.

export type LandingPageLoaderResult =
  | { status: "ok"; data: LandingPageDoc }
  | { status: "not-found" }
  | { status: "hidden" }
  | { status: "error" };

interface CallableError {
  code?: string;
  details?: { reason?: string };
}

const resultForError = (error: unknown): LandingPageLoaderResult => {
  const { code, details } = (error ?? {}) as CallableError;
  if (details?.reason === LANDING_PAGE_REFUSAL_REASON.HIDDEN) return { status: "hidden" };
  return code === "functions/invalid-argument" ? { status: "not-found" } : { status: "error" };
};

export async function loader({ params }: LoaderFunctionArgs): Promise<LandingPageLoaderResult> {
  const { page } = params;
  if (!page) return { status: "not-found" };

  try {
    const response = (await getLandingPageDataByName(page)) as {
      data: GetLandingPageByNameResponse;
    };
    return response.data ? { status: "ok", data: response.data } : { status: "not-found" };
  } catch (error) {
    return resultForError(error);
  }
}
